import React from 'react'
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BiSearch } from "react-icons/bi";

import { exploreMerchantKeyword } from '../../../../application/actions/exploreActions';

import './SearchBar.css'
import { t } from '../../../../miscellaneous/language';

const MerchantSearch = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [searchInput, setSearchInput] = React.useState('');

    const submitSearch = (e) => {
        e.preventDefault();

        const keyword = searchInput.trim().toLowerCase();
        if (keyword.length >= 2) {
            dispatch(exploreMerchantKeyword(keyword));
        }

        history.push('/explore');
    }

    return (
        <form className="search-input-container search-form" onSubmit={submitSearch}>
            <input
                type="text"
                className="search-input"
                onChange={(e) => setSearchInput(e.target.value)}
                placeholder={t.placeholder.searchHome}
                value={searchInput}
                autoComplete="off"
            />
            <button className='search-input-button-wrapper' type="submit" aria-label="Search">
                <BiSearch size={25} className="search-input-button" />
            </button>
        </form>
    )
}

export default MerchantSearch
